import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

export const MaestroIcon = ({ height, width }: { height: any; width: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-maestro">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="maestro" clipPath="url(#clip-maestro)" accessible={false} tabIndex={-1}>
        <G id="maestrocard" transform="translate(4 8.473)" accessible={false} tabIndex={-1}>
          <Path
            id="Path_501"
            data-name="Path 501"
            d="M1929.7,977.618v-.288h-.075l-.087.2-.086-.2h-.075v.288h.053V977.4l.081.187h.055l.081-.188v.217Zm-.476,0v-.239h.1v-.048h-.245v.048h.1v.239h.053Z"
            transform="translate(-1905.927 -965.606)"
            fill="#0099df"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_502"
            data-name="Path 502"
            d="M736.269,143.833H729.78V132.17h6.489Z"
            transform="translate(-721.025 -130.585)"
            fill="#6c6bbd"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_503"
            data-name="Path 503"
            d="M9.167,7.416A7.4,7.4,0,0,1,12,1.585a7.417,7.417,0,1,0,0,11.663A7.4,7.4,0,0,1,9.167,7.416"
            fill="#eb001b"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_504"
            data-name="Path 504"
            d="M1012.21,7.417a7.417,7.417,0,0,1-12,5.831,7.418,7.418,0,0,0,0-11.663,7.417,7.417,0,0,1,12,5.831"
            transform="translate(-988.21 0)"
            fill="#0099df"
            accessible={false}
            tabIndex={-1}
          />
        </G>
      </G>
    </Svg>
  )
}
